import Tracker from '@openreplay/tracker';
import { v4 as uuidV4 } from 'uuid';

function defaultGetUserId() {
  return uuidV4();
}

export function startTracker(config) {
  const getUserId = (config?.userIdEnabled && config?.getUserId) ? config.getUserId : defaultGetUserId;

  const trackerConfig = {
    projectKey: config?.projectKey,
    ingestPoint: config?.ingestPoint,
    //__DISABLE_SECURE_MODE: true // Added For local testing
  };

  const tracker = new Tracker(trackerConfig);

  if (config?.userIdEnabled) {
    const userId = getUserId();
    tracker.setUserID(userId);
  }

  try {
    tracker.start().then((session) => {
      if (session.success) {
        console.log("OpenReplay tracker started successfully.");
      } else {
        console.error("Tracker start was not successful due to:", session.reason);
      }
    });
  } catch (error) {
    console.error("Error starting tracker:", error);
  }

  return tracker;
}

export default {
  install(Vue, options) {
    if (process.env.NODE_ENV === 'development') {
      console.log("OpenReplay tracker is disabled in development mode.");
      return;
    }

    console.log(`Starting OpenReplay tracker in ${process.env.NODE_ENV} mode.`);

    const tracker = startTracker({
      userIdEnabled: true,
      projectKey: options.projectKey,
      ingestPoint: options.ingestPoint
    });

    if (tracker) {
      Vue.prototype.$tracker = tracker;

      Vue.prototype.$setUserId = function(newUserId) {
        if (this.$tracker && typeof this.$tracker.setUserID === 'function') {
          this.$tracker.setUserID(newUserId);
          console.log(`User ID set dynamically to: ${newUserId}`);
        } else {
          console.error("Tracker is not initialized or setUserID is not a function.");
        }
      };
    } else {
      console.warn("Tracker was not initialized.");
    }
  }
};
